<template>
  <v-dialog
    v-model="visible"
    width="80%"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    scrollable
    persistent
    content-class="elevation-0"
  >
    <v-card>
      <v-card-title>
        {{ nachricht.message.subject }}
        <v-spacer></v-spacer>
        <v-btn icon @click="deleteMail(nachricht.id)"><v-icon>delete</v-icon></v-btn>
        <v-chip label small v-if="nachricht.status">{{ nachricht.status }}</v-chip>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-subtitle class="pa-2">
        <div class="subtitle-2" v-if="nachricht.datum">
          {{ $filters.date(nachricht.datum, "DD.MM.YYYY hh:mm") }} Uhr
        </div>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-subtitle class="subtitle-2 pa-2">
        Von:
        <span v-if="nachricht.absender.position">{{ nachricht.absender.position }}</span>
        <span v-if="nachricht.absender.name">{{ nachricht.absender.name }}</span>
        <span v-if="nachricht.von">{{ $filters.user(nachricht.von, bbrbbr) }}</span>
        <div v-if="nachricht.an" class="mt-1">
          An:
          <v-chip label class="mr-1" small v-for="(item2, index2) in nachricht.gruppen" :key="index2 * 2">
            <v-avatar left><v-icon>group</v-icon></v-avatar>
            {{ item2 }}
          </v-chip>
          <v-chip pill class="mr-1" small v-for="(item, index) in nachricht.an" :key="index * 2 + 1">
            <v-avatar left><v-icon>account_circle</v-icon></v-avatar>
            {{ $filters.user(item, bbrbbr) }}
          </v-chip>
        </div>
        <div v-if="nachricht.an_cc" class="mt-1">
          CC:
          <v-chip pill class="mr-1" small v-for="(item, index) in nachricht.an_cc" :key="index">
            <v-avatar left><v-icon>account_circle</v-icon></v-avatar>
            {{ $filters.user(item, bbrbbr) }}
          </v-chip>
        </div>
        <div v-if="nachricht.an_bcc" class="mt-1">
          BCC:
          <v-chip pill class="mr-1" small v-for="(item, index) in nachricht.an_bcc" :key="index">
            <v-avatar left><v-icon>account_circle</v-icon></v-avatar>
            {{ $filters.user(item, bbrbbr) }}
          </v-chip>
        </div>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text class="ma-0 pa-0">
        <v-sheet style="overflow-y: scroll" max-height="calc(100vh - 404px)" v-html="nachricht.message.html"></v-sheet>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn text @click="close()">Abbrechen</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ["nachricht", "visible"],
    data() {
      return {
        attachments: [],
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
    },
    methods: {
      close() {
        this.$emit("close", false);
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// dialogMail.vue?1965de71